const LABEL_GRAY = '#8b8b8b';

const INPUT_TEXT_GRAY = '#686868';

const HOVER_GRAY = '#cecece';

export { LABEL_GRAY, INPUT_TEXT_GRAY, HOVER_GRAY };
